import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

import { AppModule } from './app/app.module';
import Environment from './environment';

setOptions({
  key: Environment?.google?.apiKey,
  v: 'weekly',
  language: window?.localStorage?.getItem('language') ?? 'en-US'
});

if (Environment.production) {
  enableProdMode();
}

Promise.all([
  importLibrary('maps'),
  importLibrary('marker'),
  importLibrary('geometry'),
  importLibrary('places'),
  importLibrary('drawing'),
  importLibrary('visualization')
]).finally(() => {
  return platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch(err => console.error(err));
});
